import React from 'react'
import cx from 'classnames'
import { H4, Intent, Classes } from '@blueprintjs/core'
import { Button, Callout, Flex, PrettyNumber } from '@ui'
import useImportSummary, { ImportSummaryData } from './hooks/useImportSummary'
import { Event } from '../NeighborhoodManagement/NeighborhoodImport/hooks/useImportDetails'
import css from './importFlow.module.scss'

interface ImportSummaryProps {
  id: string
  onSummary: (id: string) => Promise<ImportSummaryData>
  onClose: () => void
}

export default function ImportSummary({ id, onSummary, onClose }: ImportSummaryProps) {
  const { loading, error, summary } = useImportSummary(id, onSummary)

  if (error) {
    return (
      <Callout faIcon="exclamation-triangle" intent={Intent.DANGER}>
        {error.message}
      </Callout>
    )
  }

  const items: { label: string; filter?: Event; value: number }[] = [
    {
      label: 'Total',
      value: summary.totalCount,
    },
    {
      label: 'Created',
      filter: 'created',
      value: summary.createdCount,
    },
    {
      label: 'Failed',
      value: summary.failedCount,
    },
  ]

  return (
    <>
      <div style={{ padding: '30px 60px 60px 60px' }}>
        <H4 style={{ marginBottom: 30 }}>Import Summary</H4>
        <Flex>
          {items.map((item, i) => (
            <Card key={i} {...item} className={loading ? Classes.SKELETON : ''} />
          ))}
        </Flex>
      </div>
      <Flex align="center" justify="flex-end" style={{ height: 50 }}>
        <Button style={{ width: 100 }} intent={Intent.PRIMARY} text="Done" onClick={onClose} />
      </Flex>
    </>
  )
}

interface ICard {
  label: string
  value: number
  className?: string
}

export function Card({ label, value, className }: ICard) {
  return (
    <div className={cx(css.wrapper, className)}>
      <div className={css.value}>
        <PrettyNumber value={value} />
      </div>
      <div className={css.label}>{label}</div>
    </div>
  )
}
